import React from 'react';
import AboutBody from '../AboutBody/AboutBody';
import AboutHeader from '../AboutHeader/AboutHeader';

const AboutUs = () => {
    return (
        <div>
            <AboutHeader />
            <AboutBody />
        </div>
    );
};

export default AboutUs;